export default __webpack_public_path__ + "static/media/icon-menu-jd.0763737b.svg";